<div class="container main width-alignment" style="max-width: 100% !important;">
  <div class="container-fluid" style="padding: 0 !important;">

    <div class="table-container">

      <div class="subscription-page">

        <!-- Header -->
        <div class="subscription-header">
          <h2 class="page-title">Subscription Plans</h2>

          <p class="page-subtitle">
            Choose the plan that best fits your practice. Upgrade, downgrade or switch anytime.
          </p>
        </div>

        <!-- API Error -->
        <div *ngIf="errorMessage" class="alert alert-danger">
          {{ errorMessage }}
        </div>

        <!-- Plans -->
        <div class="plans-grid" *ngIf="plans?.length">

          <div *ngFor="let plan of plans; let i = index" class="plan-card"
            [class.plan-card--current]="isCurrentPlan(plan)" [class.plan-card--popular]="i === 1">

            <!-- Most Popular -->
            <!-- <div *ngIf="i === 1" class="popular-badge">
              MOST POPULAR
            </div> -->

            <!-- Plan Name -->
            <h2 class="plan-name">
              {{ getDisplayPlanName(plan.name) }}
            </h2>

            <!-- Description -->
            <p class="plan-description">
              {{ getPlanDescription(plan, i) }}
            </p>

            <!-- Divider & Includes-->
            <div class="plan-divider"></div>

            <div class="user-counter" *ngIf="!isSoloCategory">
              <label>Users</label>

              <div class="counter" *ngIf="plan.action?.type !== 'CURRENT'">
                <button type="button" (click)="decreaseUsers(plan)">−</button>

                <span>{{ plan.users_allowed }}</span>

                <button type="button" (click)="increaseUsers(plan)">+</button>
              </div>
               <span *ngIf="plan.action?.type === 'CURRENT'">{{ plan?.users_allowed }}</span>
            </div>

            <!-- Amount comes from API in paise, formatAmount converts to ₹ -->
            <div class="plan-price-block">

              <!-- Price -->

              <span class="plan-price" *ngIf="plan.action?.type !== 'CURRENT'">{{ getPlanPrice(plan) }}</span>
              <span class="plan-price" *ngIf="plan.action?.type === 'CURRENT'">{{ plan.current_price }}</span>
              <span class="plan-price-label">
                {{ plan.users_allowed }} USER{{ plan.users_allowed > 1 ? 'S' : '' }} / MONTH
              </span>
            </div>

            <!-- Current Plan -->
            <button *ngIf="plan.action?.type === 'CURRENT'" type="button" class="plan-btn current-plan-btn" disabled>
              <i class="bi bi-check-circle-fill me-1"></i>
              {{ plan.action?.label }}
            </button>


            <!-- Subscribe / Upgrade / Downgrade -->
            <!-- <button *ngIf="plan.action?.type !== 'CURRENT' && plan.action?.enabled" type="button" class="plan-btn"
              [class.plan-btn--blue]="i === 1" [class.plan-btn--outline]="i !== 1"
              [disabled]="loadingPlanId === plan.id" (click)="onSubscribe(plan)">
              <ng-container *ngIf="loadingPlanId !== getPlanActionId(plan)">
                {{ plan.action?.label }}
              </ng-container>
            
              <ng-container *ngIf="loadingPlanId === getPlanActionId(plan)">
                Processing...
              </ng-container>
            </button> -->

          <button
  *ngIf="plan.action?.type !== 'CURRENT' && plan.action?.enabled"
  type="button"
  class="plan-btn"
  [class.plan-btn--blue]="i === 1"
  [class.plan-btn--outline]="i !== 1"
  [disabled]="loadingPlanId === getPlanActionId(plan)"
  (click)="onSubscribe(plan)">

  <ng-container *ngIf="loadingPlanId !== getPlanActionId(plan)">
    {{ plan.action?.label }}
  </ng-container>

  <ng-container *ngIf="loadingPlanId === getPlanActionId(plan)">
    Processing...
  </ng-container>

</button>

          </div>

        </div>

        <!-- Loading -->
        <div *ngIf="plans?.length === 0 && !errorMessage" class="empty-state-container">
          <p class="empty-state-subtitle">
            Loading plans...
          </p>
        </div>

        <!-- Secure AutoPay -->
        <div *ngIf="plans?.length" class="autopay-card">

          <div class="autopay-left">

            <div class="autopay-icon">
              <i class="bi bi-shield-fill-check"></i>
            </div>

            <div class="autopay-content">
              <strong>Secure AutoPay</strong>

              <p>
                All plans include secure AutoPay for hassle-free monthly payments.
              </p>
            </div>

          </div>

          <div class="payment-methods">

            <!-- UPI AutoPay -->
            <div class="payment-logo upi-logo">
              <span class="upi-main">UPI</span>
              <span class="upi-sub">AUTO PAY</span>
            </div>

            <!-- RuPay -->
            <div class="payment-logo rupay-logo">
              <span>RuPay</span>
            </div>

            <!-- VISA -->
            <div class="payment-logo visa-logo">
              VISA
            </div>

            <!-- Mastercard -->
            <div class="mastercard-logo">
              <span class="mastercard-circle mastercard-red"></span>
              <span class="mastercard-circle mastercard-orange"></span>
            </div>

          </div>

        </div>

        <!-- Support -->
        <div *ngIf="plans.length > 0" class="subscription-support">
          <span>Need help choosing a plan ?</span>
        
          <button type="button" class="support-link">
            <a class="header-icon" title="Contact Support" href="#" onclick="window.open(
                                  'https://mail.google.com/mail/?view=cm&fs=1&to=support@lexiz.ai&su=Support%20Request',
                                  '_blank'); return false;">
              <i class="material-icons icon-img" style="font-size:12px">support_agent</i>&nbsp;
              <u>Contact Support</u>
            </a>
          </button>
        </div>

      </div>

    </div>

  </div>
</div>



<!-- Downgrade Success Modal -->
<div class="custom-modal-backdrop" *ngIf="showDowngradeModal">

  <div class="custom-modal">

    <!-- Close -->
    <button
      type="button"
      class="modal-close"
      (click)="closeDowngradeModal()">
      ×
    </button>

    <!-- Warning Icon -->
    <div class="modal-icon">
      <i class="material-icons">info</i>
    </div>

    <!-- Title -->
    <h2 class="modal-title">
      Downgrade Request
    </h2>

    <!-- Message -->
    <p class="modal-message">
      {{ downgradeMessage }}
    </p>

    <!-- Button -->
    <button
      type="button"
      class="modal-confirm-btn"
      (click)="closeDowngradeModal()">
      OK
    </button>

  </div>

</div>

<ngx-spinner size="medium" type="ball-clip-rotate"></ngx-spinner>